'use client';

import { c as _c } from "react/compiler-runtime";
import { IconButton } from '@repo/design-system/components/ds/button';
import { Icon } from '@repo/design-system/components/ds/icon';
import { DropdownMenu } from '@repo/design-system/components/ui/dropdown-menu';
import { useT } from '@repo/i18n/components/i18n.client';
import { css } from '@repo/panda/css';
import { useLayerControl } from '../map-controls/hooks/useLayerControl';
import { LayerControlMenuItems } from '../map-controls/layer-control-menu-items';
export const MobileLayerControlButton = () => {
  const $ = _c(11);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["game_map"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useT(t0);
  const {
    hasAnyLayerOption
  } = useLayerControl();
  if (!hasAnyLayerOption) {
    return null;
  }
  let t1;
  if ($[1] !== t) {
    t1 = t(_temp);
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = css({
      minWidth: "[48px]",
      width: "[48px]",
      minHeight: "[48px]",
      height: "[48px]",
      maxHeight: "[48px]",
      borderRadius: "full",
      flexShrink: 0,
      backgroundColor: "whiteAlpha.20",
      padding: "0"
    });
    t3 = <Icon icon="layers" decorative={true} />;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t2) {
    t4 = <IconButton variant="ghost" color="primary" size="sm" aria-label={t1} className={t2}>{t3}</IconButton>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <LayerControlMenuItems />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4) {
    t6 = <DropdownMenu size="sm" variant="dark" placement="bottom-end" closeOnSelect={false} trigger={t4}>{t5}</DropdownMenu>;
    $[9] = t4;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
function _temp($) {
  return $.layer_controls;
}